import { Table } from "reactstrap";
import { formatDate, formatPrice } from "../../../utils/helper/helpers";
import { Badges } from "../../../AbstractElements";
type Items = { [key: string]: any };

const TableauShowDiamond = ({ versements }: { versements: Items }) => {


    return (
        <Table bordered responsive className="text-center">
            <thead>
                <tr className="f-17">
                    <th scope="col">DATE PAIEMENT</th>
                    <th scope="col">TYPE DE MATERIEL</th>
                    <th scope="col">QUANTITE TONNE</th>
                    <th scope="col">QUANTITE SAC</th>
                    <th scope="col">SITUATION STOCK</th>
                </tr>
            </thead>
            <tbody>
                <tr className="f-17">
                    <td className="text-capitalize">{formatDate(versements?.pv_date_paiement)}</td>
                    <td>{versements?.materiel}</td>
                    <td>{parseInt(versements?.quantite_tonne).toLocaleString("gn-GN")} Tonnes</td>
                    <td>{(Math.round(versements?.quantite_tonne * 20)).toLocaleString("gn-GN")} Sacs</td>
                    <td>
                        {
                            versements?.qt_update > 0 ? (<Badges color="light-success" className="mb-2 fw-bold text-dark">
                                Qte Disponible
                                <Badges color="light-dark" className="ms-2">{parseInt(versements?.qt_update).toLocaleString('gn-GN')}T</Badges>
                            </Badges>) : (
                                <Badges color="light-success" className="mb-2 fw-bold text-dark">
                                    Qte Indisponible
                                </Badges>
                            )
                        }

                    </td>
                </tr>
            </tbody>
        </Table>
    )
}

export default TableauShowDiamond;